import polylabel from "polylabel"

// polylabel-Präzision in Grad (~1 m); 1.0 wäre ~111 km und läge bei kleinen Polygonen daneben
const PRECISION = 1e-5

// Visuelles Zentrum (pole of inaccessibility) eines Polygons/MultiPolygons als [lng, lat].
// polylabel erwartet Polygon-coordinates (Ring-Arrays); bei MultiPolygon größte Fläche wählen.
export function polygonLabelPoint(feature) {
  const geom = feature?.geometry
  if (!geom) return null
  try {
    if (geom.type === "Polygon") {
      const [lng, lat] = polylabel(geom.coordinates, PRECISION)
      return [lng, lat]
    }
    if (geom.type === "MultiPolygon") {
      let best = null
      let bestArea = -Infinity
      for (const poly of geom.coordinates) {
        const ring = poly[0]
        // grobe Ringfläche als Auswahlkriterium (Shoelace, Vorzeichen egal)
        let area = 0
        for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
          area += (ring[j][0] + ring[i][0]) * (ring[j][1] - ring[i][1])
        }
        area = Math.abs(area)
        if (area > bestArea) {
          bestArea = area
          best = poly
        }
      }
      if (best) {
        const [lng, lat] = polylabel(best, PRECISION)
        return [lng, lat]
      }
    }
  } catch {}
  return null
}
